import { z } from 'zod'

import { SessionIdSchema } from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { ClaimsSchema } from './schemas/access-token.ts'

export const AuthenticationSchema = z.object({
  userId: z.string(),
  sessionId: SessionIdSchema,
  claims: ClaimsSchema,
})

export type Authentication = ZodInfer<typeof AuthenticationSchema>
